import React from "react";
import { useTranslation } from "react-i18next";
import { CubeIcon } from "@heroicons/react/20/solid";

/**
 * Chip for handling-list pick progress from API `item_list_product_status`
 * (report / work order, calendar `module_details`, or report payload).
 */
export const ItemListProductStatusTag = ({
  event,
  status: statusProp,
  className = "",
  /** Smaller chip (e.g. section card footer) */
  compact = false,
}) => {
  const { t } = useTranslation();
  const raw =
    statusProp ||
    event?.module_details?.item_list_product_status ||
    event?.item_list_product_status;

  if (!raw || !raw.lines_total) {
    return null;
  }

  const linesTotal = Number(raw.lines_total) || 0;
  const linesPicked = Number(raw.lines_picked) || 0;
  const listStatus = raw.list_status;

  const allPicked = linesPicked >= linesTotal && linesTotal > 0;
  const somePicked = linesPicked > 0;
  const color = allPicked
    ? "bg-emerald-100 text-emerald-800"
    : somePicked
      ? "bg-amber-100 text-amber-800"
      : "bg-slate-100 text-slate-700";

  const statusLabel = listStatus
    ? t(`project.item_list.status.${listStatus}`, { defaultValue: listStatus })
    : "—";

  const title = t("item_list_handling.pick_progress_tooltip", {
    picked: linesPicked,
    total: linesTotal,
    status: statusLabel,
  });

  const sizeCls = compact ? "gap-0.5 px-1.5 py-0.5 text-[10px] leading-tight" : "gap-1 px-2 py-1 text-xs";
  const iconCls = compact ? "h-2.5 w-2.5" : "h-3 w-3";

  return (
    <div
      className={`inline-flex max-w-full items-center rounded-full font-medium ${sizeCls} ${color} ${className}`}
      title={title}
    >
      <CubeIcon className={`${iconCls} shrink-0`} />
      <span className="truncate">
        {t("item_list_handling.pick_progress_short", {
          picked: linesPicked,
          total: linesTotal,
        })}
      </span>
    </div>
  );
};
